import React, { useCallback } from 'react';

import auth from '~/auth';

import { Button } from '@mui/material';

import LELogoIcon from '~/components/Icons/LELogo';

interface SsoSignInButtonProps {
  onError?: (message: string) => void;
}

function SsoSignInButton({ onError }: SsoSignInButtonProps) {
  const handleClick = useCallback(() => {
    void auth.startLogin({ provider: 'v2' }).catch((error) => {
      onError?.(error instanceof Error ? error.message : 'SSO login failed');
    });
  }, [onError]);

  return (
    <Button variant="contained" onClick={handleClick}>
      Sign in with <LELogoIcon sx={{ height: 22, width: 22, marginLeft: 0.7 }} />
    </Button>
  );
}

export default SsoSignInButton;
